export default "__VITE_ASSET__667c19a3__"